import React, { useState, useRef } from 'react'
import { InputField, FlashMessage, GlobalLoader, ModalAlert, Modal, TextEditor } from '@reactiveonline/reactive_admin_shared-packages'
import moment from 'moment-timezone'
import { SingleDatePicker } from 'react-dates'
import Toggle from "react-toggle"

export default function Notes({
  canDeleteOrUpdateOldNotes, notes, notesPath, setNotes, currentAdminEmail
}) {
  const [editText, setEditText]                   = useState('')
  const [openNoteModalId, setOpenNoteModalId]     = useState(null)
  const [deleteNoteModalId, setDeleteNoteModalId] = useState(null)
  const [loading, setLoading]                     = useState(false)
  const [selectedDate, setSelectedDate]           = useState(moment(new Date()).add(1, 'day'))
  const [focusedInput, setFocusedInput]           = useState(null)
  const [optForReminder, setOptForReminder]       = useState(false)

  const flashMessageRef = useRef(null)

  function saveNote(noteId) {
    setLoading(true)

    let fd = new FormData()
    if(!noteId.startsWith('new')) {
      fd.append('note[id]', noteId)
    }
    fd.append('note[text]', editText)
    
    if (optForReminder) {
      fd.append('note[reminder_date]', selectedDate)
    } else {
      fd.append('note[reminder_date]', null)
    }

    Rails.ajax({
      type: noteId.startsWith('new') ? 'POST' : 'PUT',
      url: `${ notesPath }${ !noteId.startsWith('new') ? '/' + noteId : '' }`,
      dataType: 'json',
      data: fd,
      success: res => {
        setNotes(res.notes)
        setLoading(false)
        setOpenNoteModalId(null)
        setEditText('')
        flashMessageRef.current.show(res.message, 'success')
      },
      error: res => {
        setLoading(false)
        flashMessageRef.current.show(res.errors, 'error')

        if (res.closeModal) {
          setOpenNoteModalId(null)
        }
      }
    })
  }

  function deleteNote(noteId) {
    setLoading(true)

    Rails.ajax({
      type: 'DELETE',
      url: `${ notesPath }/${ noteId }`,
      dataType: 'json',
      success: res => {
        setNotes(res.notes)
        setLoading(false)
        setDeleteNoteModalId(null)
        flashMessageRef.current.show(res.message, 'success')
      },
      error: res => {
        setLoading(false)
        setDeleteNoteModalId(null)
        flashMessageRef.current.show(res.errors, 'error')
      }
    })
  }

  const handleCloseModal = _ => {
    setOpenNoteModalId(null)
    setEditText('')
    setFocusedInput(null)
    setSelectedDate(moment(new Date()).add(1, 'day'))
    setOptForReminder(false)
  }

  const handleEditClick = note => {
    setEditText(note.text)
    setOpenNoteModalId(`${ note.id }`)
    setOptForReminder(!!note.reminder_date)
    if (!!note.reminder_date) {
      setSelectedDate(moment(note.reminder_date))
    } else {
      setSelectedDate(moment(new Date()).add(1, 'day'))
    }
  }

  const stripHtml = html => {
    const div = document.createElement('div')
    div.innerHTML = html
    return div.textContent || div.innerText || ''
  }

  return (
    <>
      <div className='card-body m-t-30'>
        <div className='flex-box flex-column'>

          { notes && notes.length > 0 &&
            <div className='flex-box flex-column'>
              <div className='flex-box items-center content-space-between'>
                <div className='flex-1 bold'>Date created</div>
                <div className='flex-1 bold'>Last edited by</div>
                <div className='flex-2 bold'>Note</div>
                <div className='flex-1 bold' style={{ textAlign: 'right' }}>Actions</div>
              </div>
              { notes.map((note, index)=> {
                return (
                  <div key={index} className='flex-box items-center content-space-between p-t-10 p-b-10' style={{ borderBottom: '1px solid #dddddd' }}>
                    <div className='flex-1'>{ note.created_at }</div>
                    <div className='flex-1'>{ note.administrator_email }</div>
                    <div className='flex-2'>{ stripHtml(note.text) }</div>
                    <div className='flex-1 flex-box items-center content-end'>
                      { (moment(new Date(), 'Europe/Athens').subtract({ minutes: 2 }) <= moment(note.created_at, 'DD/MM/YYYY H:mm', 'Europe/Athens') || canDeleteOrUpdateOldNotes) &&
                        <>
                          <i className='m-r-20 pointer fa-light fa-trash' onClick={ () => { setDeleteNoteModalId(note.id) } } />
                          <i className='pointer fa-light fa-pen-to-square' onClick={ _ => handleEditClick(note) } />
                        </>
                      }
                    </div>
                  </div>
                )
              })
              }
            </div>
          }

          <div className='flex-box items-center content-end m-t-20'>
            <button
              onClick={ () => setOpenNoteModalId(`new-${Math.floor(100000 + Math.random() * 900000)}`) }
              className='btn reverted'
            >
              Add Note
            </button>
          </div>
        </div>
      </div>

      { openNoteModalId &&
        <Modal
          closeModal={ handleCloseModal }
          mode={ 'large' }
          action={ ()=> saveNote(openNoteModalId) }
          disableAction={ false }
          visible
          actionText={ ReactiveCore.translations.add }
        >
          <>
            <InputField label={ 'Add your note' }>
              <TextEditor
                content={ editText }
                setContent={ setEditText }
              />
            </InputField>

            { (openNoteModalId.startsWith('new') || currentAdminEmail === notes.find(el => `${ el.id }` === openNoteModalId).administrator_email) &&
              <>
                <div className='flex-box content_start'>
                  <div className='p-r-10'>
                    <label>{ Support.translations.account.receive_reminder }</label>
                  </div>

                  <Toggle
                    icons={{ unchecked: null }}
                    className='reactToggle-element small'
                    checked={ optForReminder }
                    onChange={ e => setOptForReminder(e.target.checked) }
                  />
                </div>

                { optForReminder &&
                  <>
                    <div className='flex-box content_start m-t-20'>
                      <SingleDatePicker
                        displayFormat={() => "DD MMM YYYY"}
                        date={ selectedDate }
                        onDateChange={ date => { setSelectedDate(date); setFocusedInput(null) } }
                        focused={ focusedInput }
                        onFocusChange={ setFocusedInput }
                        id="date_picker_id"
                        hideKeyboardShortcutsPanel
                        isOutsideRange={ date => date < moment(new Date()).add(1, 'day') }
                      />
                    </div>
                  </>
                }
              </>
            }
          </>
        </Modal>
      }

      { deleteNoteModalId &&
        <ModalAlert
          cancelText={ ReactiveCore.translations.invoicing_onboarding.cancel }
          acceptText={ ReactiveCore.translations.invoicing_onboarding.accept }
          alert={ ReactiveCore.translations.invoicing_onboarding.cancellation_alert }
          onSelect={ ()=> deleteNote(deleteNoteModalId) }
          onClose={ () => setDeleteNoteModalId(null) }
        />
      }

      { loading &&
        <GlobalLoader fullPage />
      }

      <FlashMessage ref={ flashMessageRef } />
    </>
  )
}
